// Kayana brand
export const Navy = "#1C1C4E";
export const Blue = "#349FFD";
export const Purple = "#2D2970";
export const Gold = "#FCCE65";
export const Green = "#4FCE9D";

// Default storefront primary; a venue's theme.base_colour overrides it.
export const PrimaryLight = "#B8DDEF";
export const Primary = Blue;
export const PrimaryDark = "#128FC9";
export const PrimaryBG = "#ffffff";

export const PrimaryContrast = "#ffffff";
export const Error = "#D93F57";
export const Success = "#1F9D6E";
export const Warning = Gold;

// Neutral text/surface scale (contrast on white: text 16:1, muted 7:1)
export const TextPrimary = Navy;
export const TextMuted = "#5B5B7B";
export const Surface = "#F6F7FB";
export const Divider = "#E3E6F0";

export const BaseFontSize = 14;
export const MobileBaseFontSize = 14;

// One 8px spacing scale; use theme.spacing(n).
export const SpacingUnit = 8;
export const MinTouchTarget = 44;

export const GreyDark = "#dbdbdb";
export const Grey = "#D8E1EF";
export const BoxShadow = "0 8px 24px rgba(28, 28, 78, 0.10)";
export const BoxShadowSm = "0 2px 8px rgba(28, 28, 78, 0.08)";
